import { render, staticRenderFns } from "./SimpleEditableTable.vue?vue&type=template&id=4d589180&"
import script from "./SimpleEditableTable.js?vue&type=script&lang=js&"
export * from "./SimpleEditableTable.js?vue&type=script&lang=js&"
import style0 from "./SimpleEditableTable.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
